<template>
  <b-card
    class="mb-3 expression-card"
    no-body
    style="border: unset"
  >
    <no-content :show="!existsExpression" />
    <template v-if="existsExpression">
      <b-card-body
        v-for="(ex, index) in model.Expressions"
        :key="index"
        class="mb-2 p-1 expression-item"
      >
        <div class="row">
          <div class="col-sm-11 expression-card-row">
            <div class="row">
              <div class="col-sm-3 expression-field">
                <input-widget
                  v-if="conditionValueFields('LeftHandSide', model.Expressions[index])"
                  :id="`rule-${ruleIndex}-condition-${conditionIndex}-expression-${index + 1}-entityField`"
                  :model="model.Expressions[index].LeftHandSide"
                  :field="conditionValueFields('LeftHandSide', model.Expressions[index])"
                  @change="onFieldSelectChange(index)"
                />
              </div>
              <div class="col-sm-3 expression-operation">
                <b-form-select
                  :id="`rule-${ruleIndex}-condition-${conditionIndex}-expression-${index + 1}-operation`"
                  v-model="model.Expressions[index].operation"
                  :options="getValues(getField(model.Expressions[index])?.dataTypeName)"
                  @change="onOperationChange(index)"
                />
              </div>
              <div
                v-if="!notRightHandSideOperation(index)"
                class="col-sm-3 expression-valueType"
              >
                <input-widget
                  :id="`rule-${ruleIndex}-condition-${conditionIndex}-expression-${index + 1}-expressionItemType`"
                  :disabled="notRightHandSideOperation(index) || isInListOperation(model.Expressions[index])"
                  :model="model.Expressions[index].RightHandSide"
                  :field="fields.RightHandSide.ExpressionItemType"
                  @change="onExpressionTypeChange(index)"
                />
              </div>
              <div
                v-if="!notRightHandSideOperation(index)"
                class="col-sm-3 expression-value"
              >
                <lookup-input-component
                  v-if="
                    getField(model.Expressions[index])
                      && (getField(model.Expressions[index]).dataTypeName === 'lookup'
                        && (model.Expressions[index].operation === 'equal' || model.Expressions[index].operation === 'notEqual')
                        && model.Expressions[index].RightHandSide.ExpressionItemType === 'literal'
                      )
                  "
                  :is-validation-rules="true"
                  :props-value="model.Expressions[index].RightHandSide"
                  :field="getField(model.Expressions[index])"
                  :is-edit-mode="true"
                  :condition-index="conditionIndex"
                  :rule-index="ruleIndex"
                  :index="index"
                />
                <input-widget
                  v-else
                  :id="`rule-${ruleIndex}-condition-${conditionIndex}-expression-${index + 1}-value`"
                  :disabled="notRightHandSideOperation(index)"
                  :model="model.Expressions[index].RightHandSide"
                  :field="conditionValueFields('RightHandSide', model.Expressions[index])"
                  :date-format="getDateFormat(getField(model.Expressions[index]))"
                  @tag="onTagAdd($event, index)"
                />
              </div>
            </div>
          </div>
          <div
            class="col-sm-1 d-flex align-items-center"
            style="max-height: 30px;"
          >
            <b-button
              :id="`rule-${ruleIndex}-condition-${conditionIndex}-expression-${index + 1}-deleteBtn`"
              v-b-tooltip
              title="Delete Expression"
              pill
              variant="outline-danger"
              @click="deleteExpression(index)"
            >
              <font-awesome-icon :icon="['fas', 'times']" />
            </b-button>
          </div>
        </div>
      </b-card-body>
    </template>
    <div class="col-4 pl-0">
      <b-dropdown
        :id="`rule-${ruleIndex}-condition-${conditionIndex}-addDropdown`"
        size="sm"
        text="Add"
        variant="secondary"
        class="connected-btn"
      >
        <b-dropdown-item
          :id="`rule-${ruleIndex}-condition-${conditionIndex}-addExpressionDropdownItem`"
          @click="onAddNewExpressionClick"
        >
          Add Expression
        </b-dropdown-item>
        <b-dropdown-item
          :id="`rule-${ruleIndex}-condition-${conditionIndex}-addConditionDropdownItem`"
          @click="onAddNewConditionClick"
        >
          Add Condition
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </b-card>
</template>

<script>
import InputWidget from '../../../../../core/components/complex-table/components/InputWidget';
import NoContent from '../../../../../core/components/NoContent';
import {createNamespacedHelpers} from 'vuex';
import {axiosClient} from '@/core/services/http.service';
import LookupInputComponent from '@/core/components/LookupInputComponent.vue';

const {
  mapState,
  mapActions: dataManagementMapActions,
} = createNamespacedHelpers('dataManagement');
export default {
  name: 'ExpressionItem',
  components: {
    LookupInputComponent,
    NoContent,
    InputWidget,
  },
  props: {
    testResp: Array,
    model: Object,
    ruleIndex: Number,
    conditionIndex: {
      type: Number,
      default: 1,
    },
    fields: Object,
    tableFields: Array,
  },
  data() {
    return {
      typesMapObject: false,
      selectedEntityType: null,
      operationField: {...JSON.parse(JSON.stringify(this.fields.operation))},
    };
  },
  computed: {
    ...mapState({
      fieldData: state => state.table.schema.fields,
      fieldValues: state => state.fieldValues,
    }),
    existsExpression() {
      return !!this.model.Expressions.length;
    },
  },
  methods: {
    ...dataManagementMapActions(['getPagedDataLookupValueItems']),
    onAddNewExpressionClick() {
      this.model.Expressions.push({
        LeftHandSide: {
          ExpressionItemType: this.fields.defaultFieldType,
          value: null,
        },
        operation: null,
        RightHandSide: {
          ExpressionItemType: null,
          value: null,
        },
      });
    },
    onAddNewConditionClick() {
      this.model.ChildLogicTrees.push({
        LogicalConjunction: null,
        ChildLogicTrees: [],
        Expressions: [],
      });
    },
    deleteExpression(index) {
      this.model.Expressions.splice(index, 1);
    },
    conditionValueFields(type, data) {
      if (!data[type]) return;
      if (data[type].ExpressionItemType === 'fieldGuid') {
        const options = this.tableFields.map(field => ({value: field.fieldGuid, text: field.displayName}));
        options.unshift({value: null, text: 'Select Entity Field', disabled: true});
        return {
          type: 'select',
          required: false,
          placeholder: 'Value',
          name: 'value',
          data: {
            options: options,
          },
        };
      }

      if (data[type].ExpressionItemType === 'literalList') {
        if (!Array.isArray(data.RightHandSide.value)) data.RightHandSide.value = [];
        return {
          type: 'tags',
          required: false,
          name: 'value',
          placeholder: ' ',
          hint: 'Type new value and press enter',
        };
      }

      if (Array.isArray(data.RightHandSide.value)) data.RightHandSide.value = null;

      if (data[type].ExpressionItemType === 'literal') {
        const field = this.getField(data);
        if (field) {
          if ((this.isFieldDate(field) || this.isFieldDateTime(field))) {
            return {
              type: this.isFieldDate(field) ? 'date' : 'datetime',
              required: false,
              placeholder: 'Value',
              name: 'value',
            };
          }
          if ((this.isFieldWholeNumber(field) || this.isFieldDecimal(field))) {
            return {
              type: 'number',
              required: false,
              placeholder: 'Value',
              name: 'value',
            };
          }
          if (this.isCheckbox(field)) {
            return {
              type: 'select',
              required: false,
              placeholder: 'Value',
              name: 'value',
              data: {
                options: [
                  {text: 'true', value: true},
                  {text: 'false', value: false},
                ],
              },
            };
          }
        }
      }
      return {
        type: 'text',
        required: false,
        placeholder: 'Value',
        name: 'value',
      };
    },
    isInListOperation(model) {
      return model.operation === 'isInList';
    },
    getValues(type) {
      const currentItems = this.typesMapObject[type];
      if(!currentItems) {
        return this.typesMapObject['*'];
      }
      const allElements = [...this.typesMapObject[type], ...this.typesMapObject['*']];
      const idx = allElements.findIndex(el => el.text === 'Select Operation');

      if (idx !== -1) {
        const [removedElement] = allElements.splice(idx, 1);
        allElements.unshift(removedElement);
      }
      return allElements;
    },
    onOperationChange(index) {
      if (this.notRightHandSideOperation(index)) {
        this.clearRightHandSide(index);
      } else {
        this.populateDefaultRightHandSide(index);
      }
      this.triggerFieldSelect(index);
    },
    async onFieldSelectChange(index) {
      const fieldGuid = this.model.Expressions[index].LeftHandSide.value;
      if (fieldGuid) {
        const field = this.tableFields.find(f => f.fieldGuid === fieldGuid);
        if (field.dataTypeName === 'lookup') {
          const id = field.dataTypeJSON.FieldToDisplayGuid;
          const relatedFieldItem = await axiosClient.get(`api/field/${id}`);
          field.relationalTableId = relatedFieldItem.body.entityGuid;
          field.relationalFieldId = id;
          //await this.getPagedDataLookupValueItems({field, query: '', isBuilder: true});
        }
      }
      if (!this.notRightHandSideOperation(index)) {
        this.populateDefaultRightHandSide(index);
      } else {
        this.clearRightHandSide(index);
      }
    },
    onExpressionTypeChange(index) {
      this.model.Expressions[index].RightHandSide.value = null;
    },
    notRightHandSideOperation(index) {
      const operation = this.model.Expressions[index].operation;
      return this.fields.nonRightHandSideOperations.map(o => o.value).includes(operation);
    },
    triggerFieldSelect(index) {
      const model = this.model.Expressions[index];

      if (this.isInListOperation(model)) {
        model.RightHandSide.ExpressionItemType = 'literalList';
      }
    },
    onTagAdd(tag, index) {
      this.model.Expressions[index].RightHandSide.value.push(tag);
    },
    clearRightHandSide(index) {
      this.model.Expressions[index].RightHandSide = null;
    },
    populateDefaultRightHandSide(index) {
      this.model.Expressions[index].RightHandSide = {
        ExpressionItemType: null,
        value: null,
      };
    },
    getField(data) {
      const field = this.tableFields.find(f => (
        f[data.LeftHandSide.ExpressionItemType] === data.LeftHandSide.value
      ));
      return data ? field : {};
    },
    isFieldDate(field) {
      if (!field) return false;
      const type = field.fieldType || field.dataTypeName;
      return type === this.fieldValues.date;
    },
    isFieldDateTime(field) {
      const type = field.fieldType || field.dataTypeName;
      return type === this.fieldValues.dateTime;
    },
    // isFieldLookup(field) {
    //   const type = field.fieldType || field.dataTypeName;
    //   return type === this.fieldValues.lookup;
    // },
    isFieldWholeNumber(field) {
      const type = field.fieldType || field.dataTypeName;
      return type === this.fieldValues.wholeNumber;
    },
    isFieldDecimal(field) {
      const type = field.fieldType || field.dataTypeName;
      return type === this.fieldValues.decimalNumber;
    },
    isCheckbox(field) {
      const type = field.fieldType || field.dataTypeName;
      return type === this.fieldValues.boolean;
    },
    getDateFormat(field) {
      if (!field) return '';
      const jsonData = field.dataTypeJSON;
      const format = 'YYYY-MM-DD';

      return `${format}${this.isFieldDate(field) ? '' : ' HH:mm:ss'}`;
    },
  },
  mounted() {
    const map = {};
    for(const option of this.fields.operation.data.options) {
      for(const type of option.fieldTypes) {
        if(type in map) {
          map[type] = [...map[type], option];
        } else  {
          map[type] = [ option];
        }
      }
    }
    this.typesMapObject = map;
  },
};
</script>

<style lang="scss" scoped>
/deep/ .b-form-tags-button {
  display: none !important;
}

/deep/ .b-form-tags {
  max-height: 35px;
  overflow: auto;
}

.card {
  border-radius: unset !important;
}

.card {
  width: 97% !important;
  margin-left: 25px !important;
}

.expression-card::before {
  content: "";
  border: 1px solid rgba(73, 80, 87, 0.5);
  position: absolute;
  left: -25px;
  z-index: 2;
  top: -22px;
  bottom: 11px;
}

.expression-card .expression-card-row::before {
  content: "";
  position: absolute;
  display: block;
  top: 15px;
  width: 28px;
  border-top: 2px solid rgba(73, 80, 87, 0.5);
  left: -12px;
  z-index: 2;
}

.connected-btn::before {
  content: "";
  position: absolute;
  display: block;
  top: 11px;
  width: 25px;
  border-top: 2px solid rgba(73, 80, 87, 0.5);
  left: -24px;
  z-index: 2;
}
</style>
